import { animate, state, style, transition, trigger } from '@angular/animations';
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { DashboardDataServiceService } from 'src/app/services/dashboard-data-service.service';
import { DebitFormDataService } from 'src/app/services/debit-form-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';

interface OzowTransactionsResponse {
  records: Record<string, unknown>[];
  totalCount: number;
}

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class PaymentHistoryComponent implements OnInit {
  form: FormGroup
  selectedIndex: any = 0
  filtershow = false;
  statusList = [{ key: '1', value: 'Completed' }, { key: '1', value: 'Pending' }, { key: '1', value: 'Error' }];
  date = new Date();
  data: any = [];
  dataSource: any = new MatTableDataSource(this.data);
  ozowTransactions: any = [];
  ozowLoading = false;
  ozowErrorMessage = '';
  ozowSearchTerm = '';
  ozowDateFrom: Date | null = null;
  ozowDateTo: Date | null = null;
  ozowCustomerNumber = '';
  ozowStatusFilter = '';
  ozowStatusOptions: any[] = [];
  ozowFiltersOpen = false;
  selectedOzowTransaction: any = null;
  ozowPageIndex = 0;
  ozowPageSize = 50;
  ozowTotalCount = 0;
  ozowDisplayedColumns =
    [
      'customer',
      'transaction',
      'date',
      'amount',
      'status',
      'actions'
    ];
  displayedColumns: string[] = [
    "CustomerNumber",
    "BankReference",
    "TransactionCode",
    "TransactionDate",
    "Status",
    "TotalAmount",
    "FeeAmount",
    "SettleAmount"
  ];
  displayedColumns1: string[] = [
    "CustomerName",
    "CustomerNumber",
    "TransactionCode",
    "TransactionDate",
    "Status",
    "TotalAmount",
  ];
  mindate: any;

  constructor(
    private formBuilder: FormBuilder,
    private debitformdatservice: DebitFormDataService,
    private dashboarddataservice: DashboardDataServiceService,
    private applicationDataService: ApplicationDataService,
    private lookupDataService: LookupDataServiceService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      status: [],
      merchantReference: [],
      transactionStartDate: [],
      transactionEndDate: []

    })
    this.lookupDataService.PaymentStatusTypeList().subscribe((result) => {
      if (result) {
        this.ozowStatusOptions = result.filter(x => x.key !== 0);
      }
    });
    this.getOzowPaymentTransactions()
  }

  filtertoggle() {
    this.filtershow = this.filtershow ? false : true;
  }
  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index
    this.clearFilter()
    if (this.selectedIndex === 0)
      this.getOzowPaymentTransactions()
    else if (this.selectedIndex === 1)
      this.getsnapscandata()
    else
      this.creditcarddata()
    this.filtershow = false;
    this.mindate = null
  }
  startdate() {
    this.mindate = new Date(this.form.value.transactionStartDate);
    this.mindate.setDate(this.mindate.getDate() + 1);
  }
  Refresh() {
    this.ozowSearchTerm = '';
    this.ozowDateFrom = null;
    this.ozowDateTo = null;
    this.ozowCustomerNumber = '';
    this.ozowStatusFilter = '';
    this.ozowPageIndex = 0;
    if (this.selectedIndex === 0)
      this.getOzowPaymentTransactions()
    else if (this.selectedIndex === 1)
      this.getsnapscandata()
    else
      this.creditcarddata()
    this.filtershow = false;
  }

  getsnapscandata() {
    this.debitformdatservice.getAllSnapScanPayment().subscribe((result) => {
      if (result) {
        this.data = result;
        this.dataSource = new MatTableDataSource(this.data);
      }
    })

  }
  creditcarddata() {
    this.dashboarddataservice.getAllCreditCardPayment().subscribe((result) => {
      if (result) {
        this.data = result
        this.dataSource = new MatTableDataSource(this.data)
      }
    })
  }

  get filteredOzowTransactions(): any[] {
    const query = this.ozowSearchTerm.trim().toLowerCase();
    const customerNumber = this.ozowCustomerNumber.trim().toLowerCase();
    return this.ozowTransactions.filter((transaction: any) =>
      (!query || [
        transaction.paymentId,
        transaction.ozowTablePaymentId === null ? '' : String(transaction.ozowTablePaymentId),
        transaction.customerName,
        transaction.customerCode,
        transaction.siteCode,
        transaction.countryCode,
        transaction.email,
        transaction.contact,
        transaction.userId,
        transaction.applicationId,
        transaction.merchantReference,
        transaction.paymentMethod,
        transaction.amount === null ? '' : String(transaction.amount),
        transaction.currency,
        transaction.paymentStatusTypeDesc,
        transaction.createdAt,
        transaction.responseCode,
        transaction.responseMessage
      ].some((value) => String(value ?? '').toLowerCase().includes(query))) &&
      (!customerNumber || String(transaction.customerCode ?? '').toLowerCase().includes(customerNumber) ||
        String(transaction.merchantReference ?? '').toLowerCase().includes(customerNumber))
    );
  }

  get pagedOzowTransactions(): any[] {
    return this.filteredOzowTransactions;
  }

  getOzowPaymentTransactions(): void {
    this.ozowLoading = true;
    this.ozowErrorMessage = '';
    const request = {
      pagination: {
        pageNumber: this.ozowPageIndex + 1,
        pageSize: this.ozowPageSize,
        searchText: this.ozowSearchTerm || null
      },
      fromDate: this.ozowDateFrom ? formatDate(this.ozowDateFrom, "yyyy-MM-dd'T'HH:mm:ss", 'en-US') : null,
      toDate: this.ozowDateTo ? formatDate(this.ozowDateTo, "yyyy-MM-dd'T'HH:mm:ss.SSS", 'en-US') : null,
      paymentStatusType: this.ozowStatusFilter || null
    };

    this.applicationDataService.getAllOzowPaymentTransactions(request).subscribe({
      next: (response: any) => {
        const result = response;
        this.ozowLoading = false;
        if (!result) {
          this.ozowTransactions = [];
          this.ozowTotalCount = 0;
          this.ozowErrorMessage = 'Unable to fetch data. Please try again.';
          return;
        }
        this.ozowErrorMessage = '';
        this.ozowTransactions = result.details;
        this.ozowTotalCount = result.totalCount;
      },
      error: (error: unknown) => {
        this.ozowLoading = false;
        this.ozowTransactions = [];
        this.ozowTotalCount = 0;
        this.ozowErrorMessage = 'Unable to fetch data. Please try again.';
        console.error('Unable to load Ozow payment transactions:', error);
      }
    });
  }

  onOzowSearch(value: string): void {
    this.ozowSearchTerm = value;
    this.ozowPageIndex = 0;
    this.getOzowPaymentTransactions()
  }

  onOzowDateFilterChange(field: 'from' | 'to', value: Date | null): void {
    if (field === 'from') {
      this.ozowDateFrom = value;
      if (this.ozowDateTo && value && this.ozowDateTo < value) {
        this.ozowDateTo = null;
      }
    } else {
      this.ozowDateTo = value;
    }
    this.ozowPageIndex = 0;
  }

  onOzowStatusFilterChange(key): void {
    this.ozowStatusFilter = key;
    this.ozowPageIndex = 0;
  }

  applyOzowFilters(): void {
    this.ozowPageIndex = 0;
    this.getOzowPaymentTransactions();
  }

  clearOzowFilters(): void {
    this.ozowDateFrom = null;
    this.ozowDateTo = null;
    this.ozowCustomerNumber = '';
    this.ozowStatusFilter = '';
    this.ozowPageIndex = 0;
    this.ozowSearchTerm = '';
  }

  onOzowPageChange(event: PageEvent): void {
    this.ozowPageIndex = event.pageIndex;
    this.ozowPageSize = event.pageSize;
    this.getOzowPaymentTransactions();
  }

  private toOzowRequestDate(value: Date | null, endOfDay: boolean): string | null {
    if (!value) {
      return null;
    }

    const date = new Date(value.getFullYear(), value.getMonth(), value.getDate());
    if (endOfDay) {
      date.setHours(23, 59, 59, 999);
    }
    return date.toISOString();
  }

  viewOzowTransaction(transaction: any): void {
    console.log('Viewing Ozow transaction:', transaction);
    this.selectedOzowTransaction = transaction;
  }

  closeOzowDetails(): void {
    this.selectedOzowTransaction = null;
  }

  isHttpPaymentUrl(value: string): boolean {
    return /^https?:\/\//i.test(value);
  }

  exportOzowTransactions(): void {
    const headers = [
      'Customer name',
      'Customer code',
      'Email',
      'Contact',
      'Payment ID',
      'Transaction ID',
      'Merchant reference',
      'Payment method',
      'Amount',
      'Status',
      'Created date',
      'Site code',
    ];
    const rows = this.filteredOzowTransactions.map((transaction) => [
      transaction.customerName === null ? '' : transaction.customerName,
      transaction.customerCode === null ? '' : transaction.customerCode,
      transaction.email === null ? '' : transaction.email,
      transaction.contact === null ? '' : transaction.contact.replace(/^\+27/, '').replace(/^\+/, ''),
      transaction.paymentId === null ? '' : transaction.paymentId,
      transaction.transactionId === null ? '' : transaction.transactionId,
      transaction.merchantReference === null ? '' : transaction.merchantReference,
      transaction.paymentMethod === null ? '' : transaction.paymentMethod,
      transaction.amount === null ? '' : transaction.amount.toFixed(2),
      transaction.paymentStatusTypeDesc === null ? '' : transaction.paymentStatusTypeDesc,
      transaction.createdAt === null ? '' : transaction.createdAt,
      transaction.siteCode === null ? '' : transaction.siteCode,
    ]);
    const csv = [headers, ...rows]
      .map((row) => row.map((value) => this.escapeOzowCsvValue(value)).join(','))
      .join('\r\n');
    const file = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'ozow-payment-transactions.csv';
    link.click();
    window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
  }

  private escapeOzowCsvValue(value: string | number): string {
    const text = String(value);
    const safeText = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
    return `"${safeText.replace(/"/g, '""')}"`;
  }

  // private extractOzowRecords(response: unknown): OzowTransactionsResponse | null {
  //   if (response === null || response === undefined) {
  //     return { records: [], totalCount: 0 };
  //   }
  //   if (Array.isArray(response)) {
  //     return response.every((record) => this.isOzowRecord(record))
  //       ? { records: response as Record<string, unknown>[], totalCount: response.length }
  //       : null;
  //   }
  //   if (!this.isOzowRecord(response)) {
  //     return null;
  //   }

  //   for (const key of ['data', 'transactions', 'result', 'items', 'details']) {
  //     const records = response[key];
  //     if (records === null) {
  //       return { records: [], totalCount: 0 };
  //     }
  //     if (Array.isArray(records)) {
  //       if (!records.every((record) => this.isOzowRecord(record))) {
  //         return null;
  //       }
  //       return {
  //         records: records as Record<string, unknown>[],
  //         totalCount: this.getOzowTotalCount(response, records.length)
  //       };
  //     }
  //     if (this.isOzowRecord(records)) {
  //       const nestedResult = this.extractOzowRecords(records);
  //       if (nestedResult) {
  //         return nestedResult;
  //       }
  //     }
  //   }
  //   return null;
  // }

  private isOzowRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  private getOzowTotalCount(response: Record<string, unknown>, fallback: number): number {
    const totalCount = Number(
      response['totalCount'] ?? response['TotalCount'] ??
      response['totalRecords'] ?? response['TotalRecords']
    );
    return Number.isFinite(totalCount) ? totalCount : fallback;
  }

  // private updateOzowStatusOptions(records: Record<string, unknown>[]): void {
  //   const statuses = records
  //     .map((record) => String(record['status'] ?? record['Status'] ?? '').trim())
  //     .filter((status) => status.length > 0);
  //   this.ozowStatusOptions = Array.from(new Set([...this.ozowStatusOptions, ...statuses]));
  // }

  getOzowStatusClass(status: string | null | undefined): string {
    const normalizedStatus = String(status ?? '').toLowerCase();
    if (normalizedStatus.includes('complete') || normalizedStatus.includes('success')) {
      return 'ozow-status-completed';
    }
    if (normalizedStatus.includes('fail') || normalizedStatus.includes('error') ||
      normalizedStatus.includes('declin') || normalizedStatus.includes('cancel') ||
      normalizedStatus.includes('void')) {
      return 'ozow-status-failed';
    }
    if (normalizedStatus.includes('pend') || normalizedStatus.includes('creat') ||
      normalizedStatus.includes('abandon')) {
      return 'ozow-status-pending';
    }
    return 'ozow-status-default';
  }

  clearFilter() {
    this.form.reset();
    this.dataSource = new MatTableDataSource(this.data)
  }
  filter() {
    const filterValues = this.form.value;
    const filteredData = this.data.filter((item) => {
      let isMatch = true;

      if (filterValues.merchantReference) {
        isMatch = isMatch && (item.merchantReference?.toLowerCase() === filterValues.merchantReference?.toLowerCase() || item.fullName?.toLowerCase() === filterValues.merchantReference?.toLowerCase());
      }

      if (filterValues.status) {
        isMatch = isMatch && item.status.toLowerCase() === filterValues.status.toLowerCase();
      }

      if (filterValues.transactionStartDate) {
        const startDate = new Date(filterValues.transactionStartDate);
        const itemDate = new Date(item.date || item.transactionTimeStamp);  // Prioritize available date
        isMatch = isMatch && itemDate >= startDate;
      }

      if (filterValues.transactionEndDate) {
        const endDate = new Date(filterValues.transactionEndDate);
        const itemDate = new Date(item.date || item.transactionTimeStamp);  // Prioritize available date
        isMatch = isMatch && itemDate <= endDate;
      }

      return isMatch;
    });

    this.dataSource = new MatTableDataSource(filteredData);
  }

}
